module.exports = __webpack_public_path__ + "static/media/privacy-policy.68c3c3cd.pdf";